import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  base: {
    paddingTop: 16,
    paddingBottom: 16,
    flexDirection: 'column',
  },
  label: {
    marginBottom: 10,
    flexShrink: 1,
  },
});
